import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Platform20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.61415 0.85688C9.85166 0.714373 10.1484 0.714373 10.3859 0.85688L17.8859 5.35688C18.3626 5.64293 18.3626 6.35707 17.8859 6.64312L15.5694 8.03299L17.8721 9.34882C18.3608 9.62803 18.3685 10.3536 17.8859 10.6431L15.5694 12.033L17.8721 13.3488C18.3608 13.628 18.3685 14.3536 17.8859 14.6431L10.3859 19.1431C10.1484 19.2856 9.85166 19.2856 9.61415 19.1431L2.11415 14.6431C1.63157 14.3536 1.63929 13.628 2.12792 13.3488L4.43061 12.033L2.11415 10.6431C1.63157 10.3536 1.63929 9.62803 2.12792 9.34882L4.43061 8.03299L2.11415 6.64312C1.63741 6.35707 1.63741 5.64293 2.11415 5.35688L9.61415 0.85688ZM5.90541 12.9179L3.98407 14.0158L10 17.6254L16.016 14.0158L14.0946 12.9179L10.3859 15.1431C10.1484 15.2856 9.85166 15.2856 9.61415 15.1431L5.90541 12.9179ZM10.3859 11.1431L14.0946 8.91788L16.016 10.0158L10 13.6254L3.98407 10.0158L5.90541 8.91788L9.61415 11.1431C9.85166 11.2856 10.1484 11.2856 10.3859 11.1431ZM3.95776 6L10 9.62536L16.0423 6L10 2.37464L3.95776 6Z'
      fill='currentColor'
    />
  </Svg>
);

Platform20.displayName = 'Platform20';
export default Platform20;
